module.exports = ReduxThunk;